import { useCallback } from "react";

import useRestMutation from "@/remoteState/useRestMutation";

export const PARNASSUS_HOST =
  process.env.NEXT_PUBLIC_PARNASSUS_URL || "/parnassus/api/v2";
const useClassroomsGet = () => {
  const createEventRecordRequest = useCallback((params) => {
    const challengesId = params.challengeId;
    const url = `${PARNASSUS_HOST}/challenges/${challengesId}/classrooms/`;
    const requestConfig = {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    };
    return new Request(url, requestConfig);
  }, []);
  return useRestMutation(createEventRecordRequest);
};

export default useClassroomsGet;
